import React from "react";
import { assets } from "../assets/assets_frontend/assets.js";
const About = () => {
  return (
    <div>
      <div>
        <h1 className="text-center text-xl font-bold" >
          About<span className="text-primary"> us</span>{" "}
        </h1>
      </div>
      <div className="my-10 flex flex-col md:flex-row gap-12">
        <img
          className="md:max-w-[360px]  w-full"
          src={assets.about_image}
          alt="wf"
        />
        <div className="flex flex-col justify-center gap-6 text-sm">
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt
            libero recusandae, odit ratione ab vero iusto quo! Maxime quam odit
            explicabo. Earum animi harum alias, obcaecati, vitae ex officiis
            quis aliquid illo minus ipsum accusamus voluptate, minima fugiat
            quas saepe?
          </p>

          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Dignissimos sint sequi delectus voluptatem error quia placeat
            recusandae doloremque, officia aliquid.
          </p>
          <p className="font-bold">our vision</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Error vel, a deleniti quidem est natus doloremque perspiciatis consectetur pariatur obcaecati.</p>
        </div>
      </div>
      <div className="text-xl my-2">      
        <h1 className=" mt-5 ">why <span className="font-gray-700 font-semibold">choose us</span> </h1>
      </div>
      <div className="flex  cursor-pointer flex-col md:flex-row p-2  w-full">
      <div className="hover:bg-primary hover:text-white duration-100 transition-all border px-20 py-10 border-gray-300">
        <h1 className="py-3 font-bold text-xl">efficient</h1>
        <p className="text-md py-2 text-gray-800">Lorem ipsum dolor sit amet.</p>
         <p className=" text-gray-800">Lorem ipsum dolor sit.</p>
      </div >
      <div className="hover:bg-primary hover:text-white duration-100 transition-all border  px-20 py-10 p-20 border-gray-300">
        <h1 className="py-3 font-bold text-xl">personalization</h1>
        <p className="text-md text-gray-800">Lorem ipsum dolor sit amet.</p>
         <p className="text-md text-gray-800">Lorem ipsum dolor sit.</p>
      </div>
      <div className="hover:bg-primary hover:text-white duration-100 transition-all border  px-20 py-10 p-20 border-gray-300">
        <h1 className="py-3 font-bold text-xl">convienince</h1>
        <p className="text-md text-gray-800">Lorem ipsum dolor sit amet.</p>
         <p className="text-md text-gray-800">Lorem ipsum dolor sit.</p>
      </div>
      </div>

    </div>
  );
};

export default About;
